export default function scanQrCode(req, res) {
    window.setShowScanner(true, (result) => {
        res.answer({ qrCode: result });
    });
}
